import { Button, Form, Input, Modal, Select } from 'antd';
import { CreateUserFormData } from '../../types/user';
import { useAppStore } from '../../store/appStore';
import { useState } from 'react';
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

interface AddUserProps {
  isCreateModalVisible: boolean;
  setIsCreateModalVisible: (visible: boolean) => void;
  addUser: (values: CreateUserFormData) => Promise<void>;
}

const AddUser = ({ isCreateModalVisible, setIsCreateModalVisible, addUser }: AddUserProps) => {
  const [form] = Form.useForm();
  const [phone, setPhone] = useState('');
  const [, setSelectedRoleId] = useState<string>('');

  const roles = useAppStore((state) => state.roles);
  const filteredRoles = roles.filter((role:any) => role.roleName !== 'super admin');
  const plants = useAppStore((state) => state.plants);
  // const zones = useAppStore((state) => state.zones);

  // Check if selected role is "ar admin"
  // const selectedRole = roles.find((role) => role.id === selectedRoleId);
  // const isArAdmin = selectedRole?.roleName === 'ar admin';

  const handleCreateCancel = () => {
    form.resetFields();
    setSelectedRoleId('');
    setPhone('');
    setIsCreateModalVisible(false);
  };

  const handleCreate = async () => {
    try {
      const values = await form.validateFields();
      const phoneData = parsePhoneNumber(phone || '');
      const payload = {
        ...values,
        phoneNumber: values.phoneNumber,
        countryCode: phoneData?.country || '', // Save country code like "UZ"
        // Only include zoneId if role is ar admin
        // ...(isArAdmin && { zoneId: values.zoneId }),
      };
      console.log('Created user:', payload);
      addUser(payload);
      // Reset form
      form.resetFields();
      setSelectedRoleId('');
      setPhone('');
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  const handleRoleChange = (roleId: string) => {
    setSelectedRoleId(roleId);
    // Clear zone selection when role changes
    form.setFieldsValue({ zoneId: undefined });
  };

  return (
    <Modal
      title="Create New User"
      open={isCreateModalVisible}
      onCancel={handleCreateCancel}
      footer={[
        <Button key="cancel" onClick={handleCreateCancel}>
          Cancel
        </Button>,
        <Button key="create" type="primary" onClick={handleCreate}>
          Add User
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" name="userForm" className="mt-4">
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please enter the name' }]}
        >
          <Input placeholder="Enter full name" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Please enter the email' },
            { type: 'email', message: 'Please enter a valid email' },
          ]}
        >
          <Input placeholder="Enter email address" />
        </Form.Item>

        <Form.Item
          name="phoneNumber"
          label="Phone Number"
          rules={[{ required: true, message: 'Please enter the phone number' }]}
        >
          <PhoneInput
            international
            defaultCountry="IN"
            value={phone}
            onChange={(phone) => setPhone(phone as string)}
            placeholder="Enter phone number"
            className="custom-phone-input"
          />
        </Form.Item>

        <Form.Item
          name="roleId"
          label="Role"
          rules={[{ required: true, message: 'Please select a role' }]}
        >
          <Select placeholder="Select role" onChange={handleRoleChange}>
            {filteredRoles.map((role) => (
              <Select.Option key={role.id} value={role.id}>
                {role.roleName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {/* Show zones field only when role is "ar admin" */}
        {/* {isArAdmin && (
          <Form.Item
            name="zoneId"
            label="Zones"
            rules={[{ required: true, message: 'Please select a zone' }]}
          >
            <Select placeholder="Select zone" optionFilterProp="children" mode="multiple">
              {zones.map((zone) => (
                <Select.Option key={zone.id} value={zone.id}>
                  {zone.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )} */}

        <Form.Item
          name="plantId"
          label="Plants"
          rules={[{ required: true, message: 'Please select at least one plant' }]}
        >
          <Select placeholder="Select plants" optionFilterProp="children">
            {plants.map((plant) => (
              <Select.Option key={plant.id} value={plant.id}>
                {plant.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddUser;
